import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/(global)/reservation/page.tsx");
